<template>
  <div class="itinerario-seccion-root" ref="itiSeccionRef">
    <!-- Contenedor de la foto superior sin espacios vacíos -->
    <div class="iti-portada-box">
      <img 
        src="@/assets/foto.webp" 
        alt="Boda Portada" 
        class="iti-img-foto" 
        ref="itiFotoRef" 
      />
    </div>

    <div class="itinerario-cuerpo">
      <h2 class="iti-main-title" ref="itiTitleRef">Itinerario</h2>

      <!-- ESTRUCTURA DE LÍNEA DE TIEMPO LATERAL -->
      <div class="iti-timeline-container">
        <!-- LÍNEA VERTICAL DIBUJADA CON SCRUB DE SCROLL -->
        <div class="iti-vertical-line" ref="itiLineRef"></div>

        <!-- LISTA DE EVENTOS -->
        <div 
          v-for="(item, index) in eventos" 
          :key="index" 
          class="iti-event-row"
          ref="itiEventCardsRef"
        >
          <!-- NODO EN LA LÍNEA DE TIEMPO -->
          <div class="iti-node-dot" ref="itiNodeDotsRef"></div>

          <!-- CONTENIDO DEL EVENTO (DERECHA) -->
          <div class="iti-event-card">
            <div class="iti-icon-wrapper">
              <img 
                :src="item.icono" 
                :class="['iti-event-icon', { 'iti-event-icon-aclarado': index === eventos.length - 1 }]" 
              />
            </div>

            <div class="iti-content-wrapper">
              <h3 class="iti-event-title">{{ item.titulo }}</h3>
              <p class="iti-event-time">{{ item.hora }}</p>
            </div>

            <div v-if="index < eventos.length - 1" class="iti-spacer-line"></div>
          </div>
        </div>

        <!-- Línea divisoria antes de la tornaboda 
        <div class="iti-spacer-line iti-tornaboda-spacer" ref="itiTornaSpacerRef"></div>

        <div class="iti-tornaboda-container" ref="itiTornaBoxRef">
          <h3 class="iti-tornaboda-title">Tornaboda</h3>
          <p class="iti-tornaboda-fecha">Domingo 11 de Octubre</p>
          <p class="iti-tornaboda-hora"> Apartir de la 1:00 PM a 10:00 PM</p>
          <p class="iti-tornaboda-lugar">Quinta Atardecer</p>
          <p class="iti-tornaboda-nota">¡Te esperamos al día siguiente<br> en el mismo lugar!</p>
        </div>-->
      </div>
    </div>

    <!-- Línea ondulada decorativa roja lateral delimitada -->
    <svg 
      class="linea-ondulada" 
      viewBox="0 0 100 800" 
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M 100,0 C 20,200 80,400 20,600 C 0,700 40,750 100,800" 
        fill="none" 
        stroke="#7A3D48 " 
        stroke-width="2.5"
        stroke-linecap="round"
      />
    </svg>

  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'ItinerarioComponent',
  setup() {
    const itiSeccionRef = ref(null);
    const itiTitleRef = ref(null);
    const itiFotoRef = ref(null);
    const itiLineRef = ref(null);
    const itiNodeDotsRef = ref([]);
    const itiEventCardsRef = ref([]); 
    const itiTornaSpacerRef = ref(null);
    const itiTornaBoxRef = ref(null);

    const eventos = [
      { titulo: 'CEREMONIA RELIGIOSA', hora: '6:00 PM', icono: require('@/assets/ing.png') },
      { titulo: 'RECEPCIÓN', hora: '8:30 PM', icono: require('@/assets/recep.png') },
      { titulo: 'ENTRADA NOVIOS', hora: '9:20 PM', icono: require('@/assets/ceremonia.png') },
      { titulo: 'CENA', hora: '10:00 PM ', icono: require('@/assets/cen.png') },
      { titulo: 'FIESTA', hora: '11:00 PM - en adelante', icono: require('@/assets/fiees.png') }
    ];

    onMounted(() => {
      // 1. Animación de entrada para foto.webp
      gsap.fromTo(itiFotoRef.value, 
        { opacity: 0, scale: 1.08 },
        { opacity: 1, scale: 1, duration: 1.5, ease: "power2.out" }
      );

      // 2. Animación del título
      gsap.fromTo(itiTitleRef.value, 
        { y: 30, opacity: 0 },
        { 
          y: 0, 
          opacity: 1, 
          duration: 0.8, 
          ease: "power2.out",
          scrollTrigger: {
            trigger: itiTitleRef.value,
            start: "top 85%",
            once: true
          }
        }
      );

      // 3. Animación progresiva vinculada al Scroll/Touch (Scrubbing)
      if (itiLineRef.value) {
        gsap.fromTo(itiLineRef.value,
          { scaleY: 0 },
          {
            scaleY: 1,
            ease: "none",
            transformOrigin: "top center",
            scrollTrigger: {
              trigger: ".iti-timeline-container",
              start: "top 70%",
              end: "bottom 80%",
              scrub: 0.5
            }
          }
        );
      }

      // 4. Aparición suave de cada nodo y tarjeta al hacer scroll
      if (itiEventCardsRef.value.length > 0) {
        itiEventCardsRef.value.forEach((card, idx) => {
          const dot = itiNodeDotsRef.value[idx];
          const icon = card.querySelector('.iti-event-icon');
          const content = card.querySelector('.iti-content-wrapper');
          const spacer = card.querySelector('.iti-spacer-line');

          const cardTl = gsap.timeline({
            scrollTrigger: {
              trigger: card,
              start: "top 80%",
              once: true
            }
          });

          if (dot) {
            cardTl.fromTo(dot,
              { scale: 0, opacity: 0 },
              { scale: 1, opacity: 1, duration: 0.4, ease: "back.out(2)" }
            );
          }

          cardTl.fromTo(icon, 
            { scale: 0, opacity: 0, rotate: -10 },
            { scale: 1, opacity: 1, rotate: 0, duration: 0.5, ease: "back.out(1.5)" },
            "-=0.2"
          )
          .fromTo(content, 
            { x: 15, opacity: 0 },
            { x: 0, opacity: 1, duration: 0.4, ease: "power2.out" },
            "-=0.2"
          );

          if (spacer) {
            cardTl.fromTo(spacer, 
              { scaleX: 0, opacity: 0 },
              { scaleX: 1, opacity: 1, duration: 0.3, transformOrigin: "left" },
              "-=0.1"
            );
          }
        });
      }

      // Animación consecutiva para el cierre de la Tornaboda
      if (itiTornaSpacerRef.value && itiTornaBoxRef.value) {
        const tornaTl = gsap.timeline({
          scrollTrigger: {
            trigger: itiTornaBoxRef.value,
            start: "top 85%",
            once: true
          }
        });

        tornaTl.fromTo(itiTornaSpacerRef.value,
          { scaleX: 0, opacity: 0 },
          { scaleX: 1, opacity: 1, duration: 0.5 }
        )
        .fromTo(itiTornaBoxRef.value,
          { y: 25, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.7, ease: "power2.out" },
          "-=0.2"
        );
      }
    });

    return { 
      eventos, 
      itiSeccionRef, 
      itiTitleRef, 
      itiFotoRef, 
      itiLineRef,
      itiTornaSpacerRef,
      itiTornaBoxRef,
      itiNodeDotsRef: (el) => { if (el) itiNodeDotsRef.value.push(el) },
      itiEventCardsRef: (el) => { if (el) itiEventCardsRef.value.push(el) } 
    };
  }
}
</script>

<style scoped>
.itinerario-seccion-root {
  position: relative;
 background-color: #F4F1E9; ; 
  padding-bottom: 90px;
  overflow: hidden;
}

.linea-ondulada {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 80px;
  height: 60%;
  pointer-events: none;
  z-index: 1;
}

.iti-portada-box {
  width: 100%;
  height: 450px;
  overflow: hidden;
}

.iti-img-foto { 
  width: 100%; 
  height: 100%; 
  object-fit: cover; 
  display: block;
}

.itinerario-cuerpo {
  position: relative;
  z-index: 2;
  padding: 40px 20px;
  max-width: 480px;
  margin: 0 auto;
}

.iti-main-title {
  font-family: 'Playfair Display', serif;
  font-size: 3.2rem;
  letter-spacing: 2px;
  color: #686D55 ; 
  margin-top: 20px;
  margin-bottom: 50px;
  font-weight: 500;
  text-align: center;
}

/* CONTENEDOR LÍNEA DE TIEMPO CON MARGEN AJUSTADO */
.iti-timeline-container {
  position: relative;
  padding-left: 38px;
  display: flex;
  flex-direction: column;
  gap: 35px;
}

/* LÍNEA VERTICAL LLEGA HASTA EL FINAL DEL ÚLTIMO TEXTO */
.iti-vertical-line {
  position: absolute;
  left: 15px;
  top: 55px;  /* Nace desde el primer nodo */
  bottom: 0px; /* Se extiende hasta la base total del último elemento */
  width: 2px;
  background-color: #7A3D48;
  z-index: 1;
  transform-origin: top center;
}

/* FILA INDIVIDUAL DE CADA EVENTO */
.iti-event-row {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

/* PUNTO DE NODO LATERAL CENTRADO EN EL ICONO */
.iti-node-dot {
  position: absolute;
  left: -29px;
  top: 55px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #7A3D48;
  border: 2px solid #fcfaf8;
  z-index: 2;
  box-shadow: 0 0 0 1px #c9b072;
}

.iti-event-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
  text-align: center;
}

.iti-icon-wrapper {
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.iti-event-icon {
  width: 110px;
  height: 110px;
  object-fit: contain;
  filter: sepia(0.8) saturate(1.2) brightness(0.5) hue-rotate(340deg);
}

/* FILTRO ACLARADO ESPECÍFICO PARA EL ÚLTIMO ICONO (fiees.png) */
.iti-event-icon-aclarado {
  filter: sepia(0.6) saturate(1.4) brightness(1.1) hue-rotate(340deg);
}

.iti-content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.iti-event-title {
  font-family: 'Playfair Display', serif;
  font-size: 15px;
  letter-spacing: 2px;
  color: #292825 ;
  margin: 0;
  font-weight: 400;
}

.iti-event-time {
  font-family: 'Playfair Display', serif;
  font-size: 16px;
  font-weight: 600;
  color: #292825; 
  margin: 0;
}

.iti-spacer-line {
  margin-top: 20px;
  width: 40px;
  height: 1px;
  background-color: #d1c4b9;
}

.iti-tornaboda-spacer {
  width: 100px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.iti-tornaboda-container {
  opacity: 0;
  text-align: center;
  padding: 10px 0;
  max-width: 400px;
}

.iti-tornaboda-title {
  font-family: 'Playfair Display', serif;
  font-size: 2.5rem;
  color: #5c4033;
  letter-spacing: 1px;
  margin: 0 0 10px 0;
  font-weight: 400;
}

.iti-tornaboda-fecha {
  font-family: 'Playfair Display', serif;
  font-size: 16px;
  letter-spacing: 1px;
  color: #2c2c2c;
  margin: 0 0 4px 0;
  font-weight: 500;
}

.iti-tornaboda-hora {
  font-family: 'Playfair Display', serif;
  font-size: 18px;
  font-weight: 600;
  color: #8c6d53;
  margin: 0 0 4px 0;
}

.iti-tornaboda-lugar {
  font-family: 'Playfair Display', serif;
  font-size: 19px !important;
  font-weight: bold;
  color: #2c2c2c;
  margin: 0 0 8px 0;
}

.iti-tornaboda-nota {
  font-family: 'Playfair Display', serif;
  font-size: 20px !important;
  font-style: italic;
  color: #6e6e6e;
  margin: 0;
}

@media (max-width: 600px) {
  .iti-portada-box { height: 320px; }
  .iti-main-title { font-size: 2.5rem; margin-bottom: 35px; }
  .iti-timeline-container { padding-left: 30px; gap: 30px; }
  .iti-vertical-line { left: 10px; top: 45px; bottom: 0px; }
  .iti-node-dot { left: -25px; top: 45px; width: 12px; height: 12px; }
  .iti-event-icon { width: 90px; height: 90px; }
  .iti-event-title { font-size: 13px; }
  .iti-tornaboda-title { font-size: 1.8rem; }
  .linea-ondulada { width: 50px; height: 50%; }
}
</style>